"use client";

import SemanticChart from "@/components/ui/SemanticChart";
import type { GlossaryChartData } from "@/lib/country/types";

interface GlossaryChartProps {
  chartData: GlossaryChartData;
}

/**
 * Thin wrapper kept for glossary call sites. The actual dataset building
 * and rendering lives in the shared SemanticChart (also used by the
 * comparison education sections).
 */
export default function GlossaryChart({ chartData }: GlossaryChartProps) {
  return <SemanticChart chartData={chartData} />;
}
